import {ChangeDetectionStrategy, Component, inject, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {IconComponent} from '../icon/icon.component';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'ucs-browser-alert-dialog',
  templateUrl: './browser-alert-dialog.component.html',
  styleUrls: ['./browser-alert-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconComponent, TranslatePipe]
})
export class BrowserAlertDialogComponent implements OnInit {
  @ViewChild('browserAlertDialog', {static: true}) browserAlertDialog: TemplateRef<any>;
  private modalService = inject(NgbModal);

  ngOnInit(): void {
    this.modalService.open(this.browserAlertDialog, {size: 'lg'});
  }
}
